/**
 * Generate a unique tag based on already existing [tags]
 *
 * @param name - name of the user
 * @param tags - already created tags for the provided [name]
 * @returns
 */
function generateTag(name: string, tags: string[]): string | undefined {
  if (!name || !tags) {
    throw Error("[name] or [tags] argument is missing");
  }

  const existingTags = tags.map((tag) => tag.substring(tag.indexOf("#") + 1, tag.length));

  const splittedName = name.toLowerCase().trim().split(" ");
  for (let i = 1000; i <= 9999; i += 1) {
    if (!existingTags.includes(i.toString())) {
      return `${splittedName.join(".")}#${i}`;
    }
  }

  return undefined;
}

export default generateTag;
